import styled from 'styled-components';

// Placeholder components for images
export const PlaceholderImage = styled.div<{
	height?: string;
	width?: string;
}>`
	background-color: #ccc;
	height: ${({ height }) => height || '200px'};
	width: ${({ width }) => width || '100%'};
	display: flex;
	align-items: center;
	justify-content: center;
	color: #555;
	font-size: 1.2rem;
	border: 1px dashed #999;
`;

// Using actual images now
export const StyledLogoImage = styled.img`
	width: 100px;
	height: 100px;
	border-radius: 2px;
	flex-shrink: 0;

	@media (max-width: 768px) {
		width: 80px;
		height: 80px;
	}
`;

export const StyledTitleImage = styled.img`

	width: min(68vw, 520px); 
	max-width: 100%; 
	height: auto; 
`;

export const ContentImage = styled.img`
	aspect-ratio: 1 / 1; 
	object-fit: cover; 
	border-radius: 6px; 

	flex: 1;
	width: 0; 
	min-width: 0;

	@media (max-width: 768px) {
		width: 100%;
		flex: none; 
	}
`;

export const WideContentImage = styled.img`
	width: 100%;
	height: 300px; 
	object-fit: cover; 
	border-radius: 6px; 
`;

// Layout components
// Removed local IniciContainer definition, using StandardContentContainer

export const HeaderSection = styled.section`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 24px;
	width: 100%;
	flex-wrap: wrap;

	@media (max-width: 768px) {
		gap: 16px; 
		flex-direction: column; 
	}
`;

export const Section = styled.section`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 16px;

	@media (max-width: 768px) {
		gap: 12px;
	}
`;

// Removed local SectionTitle definition, using import

// Removed local Paragraph definition, using import

export const ThreeImageContainer = styled.div`
	display: flex;
	gap: 16px;
	width: 100%;

	@media (max-width: 768px) {
		flex-direction: column; 
		gap: 12px; 
	}
`;
